import { render, staticRenderFns } from "./privacy-policy-content.vue?vue&type=template&id=7fc987d3&"
import script from "./privacy-policy-content.vue?vue&type=script&lang=js&"
export * from "./privacy-policy-content.vue?vue&type=script&lang=js&"
import style0 from "./privacy-policy-content.vue?vue&type=style&index=0&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports